import React from 'react'

import { getUserDisplayName } from '../../../apps/professional-app/fa/common/aifeatures/utils'

import { SelectOption } from '../../../components/SelectDropdown/SelectDropdown'

import { User } from '../../../models/User'

import { ContactDisplayLabel } from '../ContactDisplay'

export const getContactOptions = (users: User[], serviceId: string): SelectOption[] => {
  return users
    .map((contact) => {
      const contactIntegration = contact.integrations?.find((i) => i.serviceId === serviceId)
      if (!contactIntegration) {
        return null
      }
      const contactLabel = `${getUserDisplayName(contact)}${contact.email ? ` (${contact.email})` : ''}`

      return { id: contactIntegration.externalId, label: contactLabel, displayLabel: <ContactDisplayLabel contact={contact} /> } as SelectOption
    })
    .filter((contactOption): contactOption is SelectOption => !!contactOption)
}
